import {
  AddBundleRequestType,
  type AddBundleToCartRequestModel,
} from '~/models/shopping_cart/AddBundleToCartRequest.api.model';
import FetchFactory from '../factory';
import type { ShoppingCartModel } from '~/models/shopping_cart/ShoppingCart.api.model';
import {
  mapApiModelToShoppingCart,
  type ShoppingCart,
} from '~/models/shopping_cart/ShoppingCart.model';

export type ShippingInformation = {};

const CONTROLLER_PATH = '/api-electra/ShoppingCart/';

class ShoppingCartModule extends FetchFactory<any> {
  /**
   * Return the products as array
   * @param asyncDataOptions options for `useAsyncData`
   * @returns
   */
  async AddBundleToCart(requestPayload: AddBundleToCartRequestModel) {
    const url = `${CONTROLLER_PATH}AddBundleToCart`;

    return await this.call('POST', url, {
      BundleRequestType:
        requestPayload.BundleRequestType ?? AddBundleRequestType.SINGLE_PLAN,
      BundlePriceId: requestPayload.BundlePriceId ?? null,
      AddRequiredProducts: requestPayload.AddRequiredProducts ?? true,
      DownPayTime: requestPayload.DownPayTime ?? null,
      NumberOfFamilyPlans: requestPayload.NumberOfFamilyPlans ?? null,
      MainFamilyPlanCellPhoneNumber:
        requestPayload.MainFamilyPlanCellPhoneNumber ?? null,
      FamilyBundlePriceId: requestPayload.FamilyBundlePriceId ?? null,
    });
  }

  async AddPacToCart(pacId: number) {
    const url = `${CONTROLLER_PATH}AddPacToCart`;

    const response = await this.call('POST', url, {
      PacId: pacId,
      AddRequiredProducts: true,
    });
    return response;
  }

  async GetShoppingCart(
    methodSystemName: string,
  ): Promise<ShoppingCart | undefined> {
    const url = `${CONTROLLER_PATH}GetShoppingCart?shoppingCartType=${methodSystemName}`;
    const cart: ShoppingCartModel = await this.get(url);
    return cart ? mapApiModelToShoppingCart(cart) : undefined;
  }

  async RemoveShoppingCartItem(shoppingCartItemId: number) {
    const url = `${CONTROLLER_PATH}RemoveShoppingCartItem/${shoppingCartItemId}`;
    return await this.call('DELETE', url, {});
  }

  async RemoveInsuranceItem(shoppingCartItemId: number) {
    //TODO This is not yet implimented in the API
    const url = `${CONTROLLER_PATH}RemoveInsuranceItem/${shoppingCartItemId}`;
    return await this.call('DELETE', url, {});
  }

  async ApplyDiscountCoupon(discountCode: string) {
    const url = `${CONTROLLER_PATH}ApplyDiscountCoupon?discountCouponCode=${discountCode}`;
    return await this.call('POST', url, {});
  }

  async AddDiscountsToCart(discountIds: number[]) {
    const url = `${CONTROLLER_PATH}AddDiscountsToCart`;

    return await this.call('POST', url, {
      DiscountIds: discountIds,
    });
  }

  async RemoveDiscountCoupon(discountCode: number) {
    // need to create a dictionary with the key removediscount-<discountId> becouse the NOP api expects this
    const dictionary: { [key: string]: number } = {};
    dictionary['removediscount-' + discountCode] = 0;
    const url = `/api-frontend/ShoppingCart/RemoveDiscountCoupon`;
    return await this.call('POST', url, dictionary);
  }
}

export default ShoppingCartModule;
